t<template>
  <div class="onsiteServiceDetail">
    <img :src="imgUrl" />

  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
      imgUrl: this.$route.query.url,
    }
  },
  mounted() {
    console.log('this.$route.query--->', this.$route.query.url)
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>
.onsiteServiceDetail{
  width:100%;
  margin: auto;
  text-align:center;
}
</style>
